import { ErrorHandler } from '@angular/core'

import * as Errors from '../../../models/errors'
import { SelectiveExceptionHandler, Utils, TokenExpiredExceptionHandler } from '../../'
import { ErrorNode } from '../../../models'

export class MergedExceptionHandler extends ErrorHandler  {

  private _errorHandlers: {[handlerClass: string]: any} = {}
  private _registeredErrorsTreeRoot: ErrorNode

  public constructor(handlerClasses: SelectiveExceptionHandler[]) {
    super()
    this._registerHandlers(handlerClasses)
  }

  public handleError(error: any) {
    try {
      error = error.rejection instanceof Error ? error.rejection : error
      const handlers = this._getHandlersForError(error)
      handlers.forEach((handler: SelectiveExceptionHandler) => {
        handler.handleError.apply(handler, [error])
      })
    } catch (e) {
      console.error('DynamicallyMergedExceptionHandler: Running nested error handler failed', e)
    }
  }

  public getHandlerInstance<T extends SelectiveExceptionHandler>(klass: {new(...args): T}): T {
    return this._errorHandlers[klass.name]
  }

  public getAllHandlerInstanceOf<T extends SelectiveExceptionHandler>(klass: {new(...args): T}): T[] {
    const result = []
    for (const handlerclass in this._errorHandlers) {
      if (this._errorHandlers[handlerclass] instanceof klass) {
        result.push(this._errorHandlers[handlerclass])
      }
    }
    return result
  }

  private _registerHandlers(handlers: SelectiveExceptionHandler[]) {
    handlers.forEach((handler) => {
      this._errorHandlers[handler.constructor.name] = handler
    })
    this._buildErrorTree(this._groupHandlersByError(handlers))
  }

  private _getHandlersForError(error: Error): SelectiveExceptionHandler[] {
    return this._registeredErrorsTreeRoot.getLowestInstance(error).handlers
  }

  private _buildErrorTree(errorNodesByError: {[ErrorClassName: string]: ErrorNode}) {
    this._registeredErrorsTreeRoot = errorNodesByError['Error']

    for (const ErrorClassName in errorNodesByError) {
      if (ErrorClassName !== 'Error') {
        this._registeredErrorsTreeRoot.children.push(errorNodesByError[ErrorClassName])
      }
    }
    this._registeredErrorsTreeRoot.orderChildren()
  }

  private _groupHandlersByError(handlers: SelectiveExceptionHandler[]): {[ErrorClassName: string]: ErrorNode} {
    const errorNodesByError: {[ErrorClassName: string]: ErrorNode} = {Error: new ErrorNode(Error)}
    handlers.forEach((handler) => {
      handler.handledErrors().forEach((errorHandle) => {
        errorNodesByError[errorHandle.name] = errorNodesByError[errorHandle.name] ||
          new ErrorNode(errorHandle)
        errorNodesByError[errorHandle.name].handlers.push(handler)
      })
    })
    return errorNodesByError
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/exception-handlers/merged-exception-handler/merged-exception-handler.ts